import { render } from "./test.vue?vue&type=template&id=3c84f23f"
import script from "./test.vue?vue&type=script&setup=true&lang=js"
export * from "./test.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "C:\\essoduke\\Web\\health-click.dev\\app\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/assets/js/hcv2/vue/views/campaign/luckybox/test.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c84f23f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c84f23f', __exports__)) {
    console.log('reload')
    api.reload('3c84f23f', __exports__)
  }
  
  module.hot.accept("./test.vue?vue&type=template&id=3c84f23f", () => {
    console.log('re-render')
    api.rerender('3c84f23f', render)
  })

}


export default __exports__